import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {LeadProviderQuery} from '../../gql/pwa/graphql.ts';
import {LeadProviders} from '../../network/lead_provider.ts';

interface State extends LeadProviderQuery {}

export const getLeadProviders = createAsyncThunk('leadProviders/getLeadProviders', async () => {
    const result = await LeadProviders.getLeadProviders();
    return result.data;
});

export const createLeadProvider = createAsyncThunk(
    'leadProviders/createLeadProviders',
    async (data: {name: string}) => {
        const result = await LeadProviders.createLeadProvider(data.name);
        return result.data;
    },
);

export const leadProvidersSlice = createSlice({
    name: 'leadProviders',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLeadProviders.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(getLeadProviders.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.leadProviders = action.payload.leadProviders;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(getLeadProviders.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
        builder.addCase(createLeadProvider.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(createLeadProvider.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.leadProviders = [
                {
                    __typename: 'LeadProviderType',
                    name: action.payload?.createLeadProvider?.name,
                    id: action.payload?.createLeadProvider?.id,
                },
            ];
        });
        builder.addCase(createLeadProvider.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
